import React, { useState, useEffect } from 'react'

//Bibliotecas
import styled from 'styled-components'
import { useForm } from 'react-hook-form'

//Componentes
import FlexContainer from '../../../components/common/FlexContainer'
import Form from '../../../components/common/Form'
import Input from '../../../components/common/Input'
import Button, { SecondaryButton, DangerButton } from '../../../components/common/Button'
import PasswordRecover from '../../../views/Login/components/PasswordRecover'
import AvatarSelection from '../../../components/common/AvatarSelection/AvatarSelection'
import Success from '../../../components/common/Success'
import Error from '../../../components/common/Error'
import Modal from '../../../components/common/Modal'
import DeleteProfile from './DeleteProfile'

//Servicios
import PerfilService from '../../../services/PerfilService'

//Hooks
import useAuth from '../../../hooks/useAuth'

//Imágenes
import { Edit, Edit3, X, Lock, Trash2 } from 'react-feather'


function EditProfile({ usuario, refreshProfile }) {
  //Estados
  const [recoverModal, setRecoverModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [avatar, setAvatar] = useState("");
  const [isDisabled, setIsDisabled] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  //Hook de atenticación
  const { refreshToken } = useAuth();

  //React Hook Form
  const { register, handleSubmit, formState: { errors }, reset } = useForm();

  //Manipuladores
  const handleToggleModal = () => {
    setRecoverModal(!recoverModal);
  }
  const handleToggleDeleteModal = () => {
    setDeleteModal(!deleteModal);
  }

  function handleAvatarSelection(a) {
    setAvatar(a);
  }

  //Utilizar el servicio de editar perfil
  const onSubmit = (data) => {
    setLoading(true);
    PerfilService.editarPerfil({ data, avatar }).then((res) => {
      refreshToken().then(() => console.log(window.location.replace('')));
      setIsDisabled(true);
      setLoading(false);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 4000)
    }).catch((error) => {
      setError(error.message);
      setLoading(false);
      setTimeout(() => {
        setError(false);
      }, 4000)
    })
  }


  //Establecer datos del usuario en los inputs del formulario
  useEffect(() => {
    reset({
      nombre: usuario.nombre,
      email: usuario.email,
      codigoCurso: usuario.codigoCurso
    });
  }, [reset, usuario]);


  return (
    <FlexContainer margin='0 0 0 64px' borderRadius="20px" minHeight="700px" width='70%' boxShadow='20px 20px 40px rgba(0, 0, 0, 0.25)' textAlign="left" justifyContent='top' padding='32px'>
      <FlexContainer flexDirection='row' justifyContent='center'>
        <h1>Tu información de perfil</h1>
        <Button width='auto' padding='8px'
          onClick={() => {
            setIsDisabled(!isDisabled); reset({
              nombre: usuario.nombre,
              email: usuario.email,
              codigoCurso: usuario.codigoCurso
            });
          }}>
          {isDisabled ? <Edit /> : <X />}
        </Button>
      </FlexContainer>
      <Form width='80%' boxShadow='none' onSubmit={handleSubmit(onSubmit)} margin='0'>
        <Input
          isDisabled={isDisabled}
          label='Nombre'
          name='nombre'
          placeholder="Ingresa tus nombres y apellidos"
          register={register}
          required={{ required: "Por favor ingresa tu nombre" }}
          error={errors.nombre} />

        <Input
          isDisabled={true}
          label='Correo electrónico'
          name='email'
          placeholder="Ingresa tu correo electrónico"
          register={register}
          required={{ required: "Por favor ingresa tu correo", pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Correo electrónico no válido" } }}
          error={errors.email} />

        {usuario.rol != 'docente' &&
          <Input
            isDisabled={isDisabled}
            label='Código de curso'
            name='codigoCurso'
            type='number'
            placeholder="Ingresa el código de tu curso"
            register={register}
            required={{ required: false }}
            error={errors.codigoCurso}
          />
        }

        <AvatarSelection handleAvatarSelection={handleAvatarSelection} activeAvatar={usuario?.avatar} isDisabled={isDisabled} />
        <Button disabled={isDisabled} loading={loading}><Edit3 />Editar</Button>
      </Form>
      {success &&
        <Success message='Tu información de perfil ha sido actualizada correctamente' margin={'0 0 16px 0'}></Success>
      }
      {error &&
        <Error message={error}></Error>
      }
      <PasswordRecover recoverModal={recoverModal} setRecoverModal={setRecoverModal} isPrivate={true} email={usuario.email}></PasswordRecover>
      <SecondaryButton disabled={isDisabled} width='70%' onClick={handleToggleModal} margin='0 0 16px 0'><Lock />Cambiar contraseña</SecondaryButton>
      <DangerButton disabled={isDisabled} width='70%' onClick={handleToggleDeleteModal} margin='0 0 16px 0'><Trash2 />Eliminar cuenta</DangerButton>
      <DeleteProfile deleteModal={deleteModal} setDeleteModal={setDeleteModal} handleToggleDeleteModal={handleToggleDeleteModal}></DeleteProfile>
    </FlexContainer>
  )
}

export default EditProfile
